import IBanner from 'interfaces/IBanner';
import RestService from './RestService';

export default class BannerService extends RestService<IBanner> {
  constructor() {
    super('banners');
  }
}
